import React from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CourierDailyOperations} from "./components/CourierDailyOperations";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";

const CustomerCourierDailyOperationsPage = () => {
    return (
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            <CourierDailyOperations />
        </CustomerFluidSubPageLayout>
    );
};

export default CustomerCourierDailyOperationsPage;
